import { useEffect, useState, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { obtenerMuestroCarrito } from '../services/motorService';
import RoomTypeRatePlanContext from '../components/contexts/RoomTypeRatePlanContext';
import Cookies from 'js-cookie';


const SESSION_EXPIRY_TIME = 1 * 60 * 1000;

const getSession = () => {
    const sessionData = localStorage.getItem('sessionData');
    return sessionData ? JSON.parse(sessionData) : null;
};

const setSession = (session) => {
    const sessionData = {
        session,
        timestamp: Date.now(),
    };
    localStorage.setItem('sessionData', JSON.stringify(sessionData));
};

const generateSession = (fetchCartCallback) => {
    const newSession = uuidv4();
    console.log('New session:--------------', newSession);
    setSession(newSession);
    const hotcod = Cookies.get('hotCod');
    fetchCartCallback(newSession, hotcod);
    return newSession;
};

const useCart = () => {
    const { setCartItems } = useContext(RoomTypeRatePlanContext);

    const fetchCart = async (session, hotcod) => {
        try {
            const cart = await obtenerMuestroCarrito(hotcod, session);
            console.log('Fetched cart:', cart);
            if (cart && cart.length > 0) {
                setCartItems(cart);
            } else {
                setCartItems([]);
                console.log('No cart data found');
            }
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }
    };

    return fetchCart;
};

const useSession = () => {
    const fetchCart = useCart();
    const hotcod = Cookies.get('hotCod');
    const [session, setSessionState] = useState(() => {
        const storedSession = getSession();
        if (storedSession) {
            const isExpired = Date.now() - storedSession.timestamp > SESSION_EXPIRY_TIME;
            if (isExpired) {
                return generateSession(fetchCart);
            } else {
                fetchCart(storedSession.session, hotcod); // Fetch cart data on initial load
            }
            return storedSession.session;
        } else {
            return generateSession(fetchCart);
        }
    });

    useEffect(() => {
        const refreshSession = () => {
            const storedSession = getSession();
            if (storedSession) {
                const isExpired = Date.now() - storedSession.timestamp > SESSION_EXPIRY_TIME;
                if (isExpired) {
                    const newSession = generateSession(fetchCart);
                    setSessionState(newSession);
                } else {
                    setSessionState(storedSession.session);
                    setSession(storedSession.session);
                }
            } else {
                const newSession = generateSession(fetchCart);
                setSessionState(newSession);
            }
        };

        const interval = setInterval(refreshSession, 60 * 1000);

        window.addEventListener('click', refreshSession);
        window.addEventListener('mousemove', refreshSession);
        window.addEventListener('keypress', refreshSession);

        return () => {
            clearInterval(interval);
            window.removeEventListener('click', refreshSession);
            window.removeEventListener('mousemove', refreshSession);
            window.removeEventListener('keypress', refreshSession);
        };
    }, [fetchCart]);


    return session;
};

export default useSession;